import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor} from '@angular/common/http';
import { AuthService } from './auth/auth.service'
@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private injector: Injector) { }
intercept (req, next){
  let authService = this.injector.get(AuthService)
  let tokenizedReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${authService.getToken()} `,
      UserId:!localStorage.getItem('userid') ? '' : localStorage.getItem('userid')
     // UserId: localStorage.getItem("userid")
    }
  })
  return next.handle(tokenizedReq)
}
}



// WEBPACK FOOTER //
// ./src/app/core/token-interceptor.service.ts